module.exports = __webpack_public_path__ + "cfe0083a.jpg";